import * as React from 'react';
import autobind from 'autobind-decorator';

import { ContractListDataService } from 'src/app/products/contract/list/contract-list.data';
import { ContractEditorView } from './contract-editor.view';

interface ContractEditorControllerProps {
    value: number | null;
    mode: ControlMode;
    onChanged: (value: ContractSummary | null) => void;
    setBusy(isBusy: boolean);
    label?: string;
	productId?: number;
	required?:boolean
}

export class ContractEditorController extends React.Component<ContractEditorControllerProps, any> {
    protected contractDataService: ContractListDataService;

    constructor(props) {
        super(props);
        this.contractDataService = ContractListDataService.make();
    }

    @autobind
    protected contractQuery(q?: string): Promise<QueryResult<ContractSummary>> {
        return new Promise<QueryResult<ContractSummary>>((resolve, reject) => {
            this.props.setBusy(true);
            this.contractDataService.addFilter('isDeleted', 'eq', false);
            this.contractDataService.addSorting('id', 'asc', true);
            this.contractDataService.searchKeywords = q;
            this.contractDataService.load(query => query)
                .then((items) => {
                    this.props.setBusy(false);
                    resolve({
                        items: items,
                        totalCount: this.contractDataService.count
                    });
                });
        });
    }

    render() {
        return (
			<ContractEditorView
				required={this.props.required}
                productRequest={{ query: this.contractQuery, dataSet: this.contractDataService }}
                label={this.props.label}
                onChanged={this.props.onChanged}
                value={this.props.value}
                mode={this.props.mode}
                productId={this.props.productId}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/products/contract/parts/contract-editor.controller.tsx